export default __webpack_public_path__ + "static/media/lowlatency.3cb22d19.svg";